<button
  class="w-full login-btn"
  mat-flat-button
  [ngClass]="{ enabled: !disabled }"
  [disabled]="disabled"
  (click)="triggerEvent()"
>
  @if(isLoading){
  <div class="button-content">
    <mat-spinner class="spinner"></mat-spinner><span>Registering...</span>
  </div>
  }@else{
  <span>{{ text }}</span>
  }
</button>
